import React from 'react';
import { useLanguage } from '../i18n';
import { getProduct, productPilotUrl, productUrl } from '../products';

/**
 * Product explanation, deployment facts and a direct pilot application.
 */
const ContextFriendSection: React.FC = () => {
  const { t, language } = useLanguage();
  const product = getProduct('contextfriend');
  const href = productUrl(product, language, 'homepage_featured') ?? '#';
  const image = product.imageByLanguage?.[language] ?? product.image;
  const pilotHref = productPilotUrl(product, language, 'homepage_featured');

  return (
    <section
      className="lp-product-section"
      id="contextfriend"
      aria-labelledby="product-heading"
      data-testid="featured-product"
    >
      <div className="lp-wrap lp-product-grid">
        <div className="lp-product-copy">
          <div className="lp-section-meta">
            <span className="lp-status" data-testid="product-status" data-status={product.status}>
              {t.contextfriend.status}
            </span>
          </div>
          <h2 id="product-heading">
            ContextFriend<span className="lp-title-dot">.</span>
          </h2>
          <p className="lp-product-statement">
            {t.contextfriend.statement}
          </p>
          <p className="lp-body-copy">{t.contextfriend.body}</p>
          <ul className="lp-product-facts">
            {t.contextfriend.facts.map((fact) => (
              <li key={fact}>{fact}</li>
            ))}
          </ul>
          <div className="lp-product-actions">
            {pilotHref && (
              <a className="lp-button" href={pilotHref} target="_blank" rel="noopener noreferrer" data-testid="product-pilot-cta">
                <span>{t.contact.pilotCta}</span><span aria-hidden="true">↗</span>
              </a>
            )}
            <a className="lp-text-link" href={href} target="_blank" rel="noopener noreferrer">
              {t.contextfriend.cta} <span aria-hidden="true">↗</span>
            </a>
          </div>
          <p className="lp-pilot-note">{t.contextfriend.recruitment}</p>
        </div>

        <figure className="lp-product-visual">
          <div className="lp-device-plate">
            <img
              className="lp-device-photo"
              src={image}
              alt={t.contextfriend.imageAlt}
              width={1448}
              height={1086}
              loading="lazy"
              decoding="async"
            />
          </div>
          <figcaption className="lp-question-example">
            <p>{t.contextfriend.exampleQuestion}</p>
          </figcaption>
        </figure>
      </div>

    </section>
  );
};

export default ContextFriendSection;
